import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from 'react'
import { COMPANIES, type Company } from '../data/companies'

interface CompanyCtx {
  companies: Company[]
  selected: Company
  setSelectedId: (id: string) => void
}

const STORAGE_KEY = 'bolag.linesp.selectedCompany'

const Ctx = createContext<CompanyCtx>({} as CompanyCtx)

export function CompanyProvider({ children }: { children: ReactNode }) {
  const [id, setId] = useState<string>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) ?? COMPANIES[0].id
    } catch {
      return COMPANIES[0].id
    }
  })

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, id)
    } catch {
      /* ignore */
    }
  }, [id])

  const selected = COMPANIES.find((c) => c.id === id) ?? COMPANIES[0]

  return (
    <Ctx.Provider value={{ companies: COMPANIES, selected, setSelectedId: setId }}>
      {children}
    </Ctx.Provider>
  )
}

export function useSelectedCompany() {
  return useContext(Ctx)
}
